// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* TipTap Placeholder Styles */
.tiptap p.is-editor-empty:first-child::before {
	color: var(--py-neutral-4); /* red-500 for red placeholder */
	content: attr(data-placeholder);
	float: left;
	height: 0;
	pointer-events: none;
}

/* Alternative selector for different TipTap versions */
.ProseMirror p.is-editor-empty:first-child::before {
	color: var(--py-neutral-4); /* red-500 for red placeholder */
	content: attr(data-placeholder);
	float: left;
	height: 0;
	pointer-events: none;
}

/* Fallback for direct ProseMirror targeting */
.ProseMirror.is-editor-empty::before {
	color: var(--py-neutral-4); /* red-500 for red placeholder */
	content: attr(data-placeholder);
	float: left;
	height: 0;
	pointer-events: none;
}

/* Word breaking and width constraints */
.tiptap {
	width: 100%;
	max-width: 100%;
	overflow: hidden;
	box-sizing: border-box;
}

.ProseMirror {
	word-break: break-word;
	overflow-wrap: anywhere;
	width: 100%;
	max-width: 100%;
	box-sizing: border-box;
	overflow: hidden;
}

.ProseMirror * {
	word-break: break-word;
	overflow-wrap: anywhere;
	max-width: 100%;
	box-sizing: border-box;
}

.ProseMirror p {
	word-break: break-word;
	overflow-wrap: anywhere;
	max-width: 100%;
	margin: 0;
}
`, "",{"version":3,"sources":["webpack://./../../packages/py-components/src/components/molecules/TextEditor/TextEditor.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;CACC,0BAA0B,EAAE,gCAAgC;CAC5D,+BAA+B;CAC/B,WAAW;CACX,SAAS;CACT,oBAAoB;AACrB;;AAEA,uDAAuD;AACvD;CACC,0BAA0B,EAAE,gCAAgC;CAC5D,+BAA+B;CAC/B,WAAW;CACX,SAAS;CACT,oBAAoB;AACrB;;AAEA,8CAA8C;AAC9C;CACC,0BAA0B,EAAE,gCAAgC;CAC5D,+BAA+B;CAC/B,WAAW;CACX,SAAS;CACT,oBAAoB;AACrB;;AAEA,wCAAwC;AACxC;CACC,WAAW;CACX,eAAe;CACf,gBAAgB;CAChB,sBAAsB;AACvB;;AAEA;CACC,sBAAsB;CACtB,uBAAuB;CACvB,WAAW;CACX,eAAe;CACf,sBAAsB;CACtB,gBAAgB;AACjB;;AAEA;CACC,sBAAsB;CACtB,uBAAuB;CACvB,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,sBAAsB;CACtB,uBAAuB;CACvB,eAAe;CACf,SAAS;AACV","sourcesContent":["/* TipTap Placeholder Styles */\n.tiptap p.is-editor-empty:first-child::before {\n\tcolor: var(--py-neutral-4); /* red-500 for red placeholder */\n\tcontent: attr(data-placeholder);\n\tfloat: left;\n\theight: 0;\n\tpointer-events: none;\n}\n\n/* Alternative selector for different TipTap versions */\n.ProseMirror p.is-editor-empty:first-child::before {\n\tcolor: var(--py-neutral-4); /* red-500 for red placeholder */\n\tcontent: attr(data-placeholder);\n\tfloat: left;\n\theight: 0;\n\tpointer-events: none;\n}\n\n/* Fallback for direct ProseMirror targeting */\n.ProseMirror.is-editor-empty::before {\n\tcolor: var(--py-neutral-4); /* red-500 for red placeholder */\n\tcontent: attr(data-placeholder);\n\tfloat: left;\n\theight: 0;\n\tpointer-events: none;\n}\n\n/* Word breaking and width constraints */\n.tiptap {\n\twidth: 100%;\n\tmax-width: 100%;\n\toverflow: hidden;\n\tbox-sizing: border-box;\n}\n\n.ProseMirror {\n\tword-break: break-word;\n\toverflow-wrap: anywhere;\n\twidth: 100%;\n\tmax-width: 100%;\n\tbox-sizing: border-box;\n\toverflow: hidden;\n}\n\n.ProseMirror * {\n\tword-break: break-word;\n\toverflow-wrap: anywhere;\n\tmax-width: 100%;\n\tbox-sizing: border-box;\n}\n\n.ProseMirror p {\n\tword-break: break-word;\n\toverflow-wrap: anywhere;\n\tmax-width: 100%;\n\tmargin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
